/* src/app/components/admin/accounts/manage-open-ai-account-setting-dialog/manage-open-ai-account-setting-dialog.component.scss */
.mat-mdc-dialog-content {
  padding: 12px 24px 12px 24px;
  min-width: 200px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
}
.dark-theme-option {
  background-color: #424242 !important;
  color: #FFFFFF !important;
}
.dark-theme-option:hover {
  background-color: #424242 !important;
  opacity: 0.9 !important;
}
.dark-theme-option:focus {
  background-color: #424242 !important;
  opacity: 0.9 !important;
}
.input-hint {
  font-size: 9.75px;
  padding-left: 15px;
  color: rgba(0, 0, 0, 0.6);
}
:host-context(.dark-theme) ::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
:host-context(.dark-theme) .mat-mdc-input-element {
  color: #FFFFFF;
  caret-color: #9fa8da !important;
}
:host-context(.dark-theme) .input-hint {
  color: rgba(255, 255, 255, 0.7019607843);
}
/*# sourceMappingURL=manage-open-ai-account-setting-dialog.component.css.map */
